// 判断文件类型
export function matchFileType(fileName) {
  // 后缀获取
  let suffix = '';
  // 获取类型结果
  let result = null;
  if (!fileName) return false;
  try {
    // 截取文件后缀
    suffix = fileName.substr(fileName.lastIndexOf('.') + 1, fileName.length)
    // 文件后缀转小写，方便匹配
    suffix = suffix.toLowerCase()
  } catch (err) {
    suffix = '';
  }
  // fileName无后缀返回 false
  if (!suffix) {
    result = false;
    return result;
  }

  let fileTypeList = [
    // 图片类型
    {'typeName': 'image', 'types': ['png', 'jpg', 'jpeg', 'bmp', 'gif']},
    // 文本类型
    {'typeName': 'txt', 'types': ['txt']},
    // excel类型
    {'typeName': 'excel', 'types': ['xls', 'xlsx']},
    {'typeName': 'word', 'types': ['doc', 'docx']},
    {'typeName': 'pdf', 'types': ['pdf']},
    {'typeName': 'ppt', 'types': ['ppt', 'pptx']},
    // 视频类型
    {'typeName': 'video', 'types': ['mp4', 'mkv', 'mpeg', 'avi', 'mov', 'wmv', 'flv', 'rmvb', '3g2', '3gp', '3gpp', 'cavs']},
    // 音频
    {'typeName': 'radio', 'types': ['mp3', 'wav', 'wma', 'ogg', 'acc', 'ac3', 'aif', 'aifc', 'aiff', 'm4a', 'au', 'flac']}
  ]
  // let fileTypeList = ['image', 'txt', 'excel', 'word', 'pdf', 'video', 'radio']
  for (let i = 0; i < fileTypeList.length; i++) {
    const fileTypeItem = fileTypeList[i]
    const typeName = fileTypeItem.typeName
    const types = fileTypeItem.types
    //   console.log(fileTypeItem);
    result = types.some(function (item) {
      return item === suffix;
    });
    if (result) {
      return typeName
    }
  }
  return 'other'
}

// 文件图片资源地址转换
export function onfileResourceChange(type) {
  switch(type) {
    case 'pdf':
      return require('@/assets/file/pdf.png');
    case 'video':
      return require('@/assets/file/video.png');
    case 'radio':
      return require('@/assets/file/audio.png');
    case 'ppt':
      return require('@/assets/file/ppt.png');
    case 'txt':
      return require('@/assets/file/txt.png');
    case 'image':
      return require('@/assets/file/pic.png');
    case 'word':
      return require('@/assets/file/doc.png');
    case 'excel':
      return require('@/assets/file/xls.png');
  }
}

// 文件单位转换
export function formatByte(val) {
  if (isNaN(val)) return "";
  var list = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  var temp = Math.floor(Math.log(val) / Math.log(2));
  if (temp < 1) temp = 0;
  var num = Math.floor(temp / 10);
  val = val / Math.pow(2, 10 * num);
  if (val.toString().length > val.toFixed(2).toString().length)
    val = val.toFixed(2);
  return val + " " + list[num];
}
